import {
  AuthError,
  type AccountInfo,
  type IPublicClientApplication,
  type RedirectRequest,
} from '@azure/msal-browser';
import LogoutOnAuthErrors from '../config/LogoutOnAuthErrors';

const getMsalAuthToken = async (
  msalAccount: AccountInfo | undefined,
  instance: IPublicClientApplication,
  scopes: string[]
): Promise<string> => {
  const request: RedirectRequest = {
    scopes: scopes,
    account: msalAccount,
  };

  try {
    // No user in cache yet, need to redirect to login
    if (!msalAccount) {
      await instance.acquireTokenRedirect(request);
      throw new Error('Redirecting for token acquisition');
    }

    // This is to fix a render issue caused by instance.acquireTokenSilent
    // causing the MSAL provider to re-render
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5796
    await Promise.resolve();
    const silentTokenResponse = await instance.acquireTokenSilent(request);

    if (!silentTokenResponse.account) {
      await instance.acquireTokenRedirect(request);
      throw new Error('Redirecting for token acquisition');
    }

    return silentTokenResponse.accessToken;
  } catch (err: unknown) {
    if (err instanceof AuthError && LogoutOnAuthErrors.includes(err.errorCode)) {
      await instance.logoutRedirect();
      throw new Error('Logged out due to authentication error');
    } else {
      console.error(err);
      throw new Error('Failed to acquire token');
    }
  }
};

export default getMsalAuthToken;
